let absoluteMaxDimension = 450;

export function maxGridDimension(resDivider) {
    const minScreenDimension = window.innerHeight < window.innerWidth ? window.innerHeight : window.innerWidth;
    //const maxSize = absoluteMaxDimension < minScreenDimension/resDivider ? absoluteMaxDimension : minScreenDimension/resDivider;
    
    // Something tricksy going on with Paul's phone.
    const maxSize = minScreenDimension/resDivider;

    return maxSize;
}

export function calSquareSize(resDivider, margin, borderWidth) {
    return (maxGridDimension(resDivider) - 10*margin - 10*borderWidth - 2*margin)/7.3; //extra 2*margin is to allow for wider outer margins for nice lookin'
}